import {
  Slot
} from "../../../chunk-5DWHOSR4.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Button/Button.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var buttonVariants = cva("buyscout-btn", {
  variants: {
    variant: {
      prominent: "buyscout-btn--variant-prominent",
      glass: "buyscout-btn--variant-glass",
      tinted: "buyscout-btn--variant-tinted",
      bordered: "buyscout-btn--variant-bordered",
      outlined: "buyscout-btn--variant-outlined",
      borderless: "buyscout-btn--variant-borderless"
    },
    color: {
      primary: "buyscout-btn--color-primary",
      success: "buyscout-btn--color-success",
      error: "buyscout-btn--color-error",
      neutral: "buyscout-btn--color-neutral",
      ink: "buyscout-btn--color-ink"
    },
    shape: {
      rounded: "buyscout-btn--shape-rounded",
      pill: "buyscout-btn--shape-pill",
      circle: "buyscout-btn--shape-circle"
    },
    size: {
      xs: "buyscout-btn--size-xs",
      sm: "buyscout-btn--size-sm",
      md: "buyscout-btn--size-md",
      lg: "buyscout-btn--size-lg",
      xl: "buyscout-btn--size-xl"
    },
    iconOnly: {
      true: "buyscout-btn--icon-only",
      false: ""
    },
    fullWidth: {
      true: "buyscout-btn--full-width",
      false: ""
    }
  },
  defaultVariants: {
    variant: "prominent",
    color: "primary",
    shape: "rounded",
    size: "md",
    iconOnly: false,
    fullWidth: false
  }
});
function Button({
  ref,
  ...props
}) {
  const {
    variant,
    color,
    shape,
    size,
    iconOnly,
    fullWidth,
    asChild = false,
    loading = false,
    className,
    children,
    onClick,
    ...rest
  } = props;
  const Comp = asChild ? Slot : "button";
  const classes = buttonVariants({ variant, color: variant === "bordered" ? "neutral" : color, shape, size, iconOnly, fullWidth, className: [loading && "buyscout-btn--loading", className].filter(Boolean).join(" ") });
  return /* @__PURE__ */ jsx(
    Comp,
    {
      ...rest,
      type: asChild ? void 0 : rest.type ?? "button",
      ref,
      className: classes,
      "aria-busy": loading || void 0,
      "aria-disabled": loading || rest["aria-disabled"],
      onClick: loading ? (event) => {
        event.preventDefault();
        event.stopPropagation();
      } : onClick,
      children: asChild ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
        loading && /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "buyscout-spinner buyscout-spinner--sm buyscout-btn__spinner" }),
        /* @__PURE__ */ jsx("span", { className: "buyscout-btn__label", children })
      ] })
    }
  );
}
Button.displayName = "Button";
function ButtonGroup({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, role: "group", className: ["buyscout-btn-group", className].filter(Boolean).join(" "), ...props });
}
ButtonGroup.displayName = "ButtonGroup";
function ButtonGroupSeparator({ className, ...props }) {
  return /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: ["buyscout-btn-group__separator", className].filter(Boolean).join(" "), ...props });
}
ButtonGroupSeparator.displayName = "ButtonGroupSeparator";
export {
  Button,
  ButtonGroup,
  ButtonGroupSeparator
};
//# sourceMappingURL=Button.mjs.map